/**
 * Reset — typeable escape hatch (`/reset`). Wipes every DACcelerate
 * localStorage key and bounces to /login. Use when the UI is stuck
 * badly enough that the header ResetSessionButton isn't reachable.
 */

import { useEffect } from 'react'
import { IMPERSONATE_STORAGE_KEY, TOKEN_STORAGE_KEY } from '../lib/constants'

const KEYS_TO_CLEAR = [
  TOKEN_STORAGE_KEY,
  IMPERSONATE_STORAGE_KEY,
  'daccelerate_v2_show_test_data',
  'daccelerate_v2_sidebar_collapsed',
  'token', // legacy
]

export function Reset() {
  useEffect(() => {
    for (const k of KEYS_TO_CLEAR) {
      try {
        localStorage.removeItem(k)
      } catch { /* ignore */ }
    }
    window.location.replace('/login')
  }, [])
  return (
    <div style={{ padding: '24px', fontFamily: 'system-ui' }}>
      Resetting session…
    </div>
  )
}
